import { render, staticRenderFns } from "./Commonbanner.vue?vue&type=template&id=c4c948b6&"
import script from "./Commonbanner.vue?vue&type=script&lang=js&"
export * from "./Commonbanner.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports